import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useLocation, useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import LocationSelector from '../../../LocationSelector';
import LoginHeader from '../../../Login_header';
import Menu from '../../../Menu';
import * as Picklist from '../../../Picklist';
import * as Common from './../../../Common';
import Dialog from './../../../Dialog';

const Rep_vtm_profitability = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const dropdownType = location.state?.dropdownType;
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [settlementGenerateType, setSettlementGenerateType] = useState("V");

    const [locationCode, setLocationCode] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [radioType, setRadioType] = useState("O");
    const [settlementType, setSettlementType] = useState("B");
    const [scr, setScr] = useState("");
    const [repLevel, setRepLevel] = useState("G");
    const [vtmFromDate, setVtmFromDate] = useState(new Date());
    const [vtmToDate, setVtmToDate] = useState(new Date());
    const [issuerOption, setIssuerOption] = useState("A");
    const [selectedIssuer, setSelectedIssuer] = useState(null);
    const [filterReportType, setFilterReportType] = useState("D");
    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', dropdownType === 'GLOBAL' ? 'REP_VTM_PROFITABILITY_GLOBAL' : 'REP_VTM_PROFITABILITY_LOCAL'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleDataFromChild = (newLocationCode, newSelectedItems, newRadioType) => {
        setLocationCode(newLocationCode);
        setSelectedItems(newSelectedItems);
        setRadioType(newRadioType);
    }

    const handleGenerate = () => {
        $(".loader").show();
        if (!Common.validateFinYear(Common.dateYMD(vtmFromDate), Common.dateYMD(vtmToDate))) {
            $(".loader").hide();
            setMsgText("Date should be within financial year");
            setMsgBox(true);
            return;
        } else if (vtmFromDate > vtmToDate) {
            $(".loader").hide();
            setMsgText("From Date should be less than To Date");
            setMsgBox(true);
            return;
        }

        var msg = [], i = 0;
        if ((radioType === 'O' && locationCode === '0') || (radioType == 'S' && selectedItems == [])) {
            msg[i++] = ((radioType == 'O' && locationCode == '0') ? "Please select location." : '');
            msg[i++] = ((radioType == 'S' && selectedItems == []) ? "Please select atleast one location." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                repLevel: dropdownType === 'GLOBAL' ? 'G' : 'L',
                settlementType: settlementType,
                issuerOption: issuerOption,
                selectedIssuer: selectedIssuer,
                fromDate: Common.dateYMD(vtmFromDate),
                fromDateDMY: Common.dateDMY(vtmFromDate),
                toDate: Common.dateYMD(vtmToDate),
                toDateDMY: Common.dateDMY(vtmToDate),
                type: settlementGenerateType,
                radioTypeLocation: radioType,
                location: locationCode,
                multipleLocation: selectedItems,
                filterReportType: filterReportType,
            };
            if (settlementGenerateType === 'D') {
                Common.callDownloadApiPost1(Common.apiVtmProfitability, "post", [sid, "vtmDownloadReport", JSON.stringify(obj)], result => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else {
                Common.callApi(Common.apiVtmProfitability, [sid, "vtmViewReport", JSON.stringify(obj)], result => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });

            }
        }
    }
    const handleIssuerChange = value => {
        setSelectedIssuer(value);
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Report VTM Profitability</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Level<span className="text-danger">*</span></Form.Label>
                            <Form.Select disabled={true} value={repLevel} onChange={e => setRepLevel(e.target.value)}
                                required>
                                {dropdownType === 'GLOBAL' ?
                                    <option value="G">Global</option> :
                                    <option value="L">Local</option>
                                }
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={settlementType} onChange={e => setSettlementType(e.target.value)}
                                required>
                                <option value="B">Both</option>
                                <option value="V">VTM</option>
                                <option value="E">EVTM</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Issuer Options<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={issuerOption} onChange={e => setIssuerOption(e.target.value)}
                                required>
                                <option value="A">All</option>
                                <option value="O">One</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {issuerOption === 'O' ?
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Issuer<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions
                                    defaultOptions
                                    value={selectedIssuer}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', locationCode)}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleIssuerChange}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col> : null}
                    <Row>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label> From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                <DatePicker className="form-control"
                                    selected={vtmFromDate}
                                    onChange={(date) => setVtmFromDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label> To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                <DatePicker className="form-control"
                                    selected={vtmToDate}
                                    onChange={(date) => setVtmToDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Report Type <span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={filterReportType} onChange={e => setFilterReportType(e.target.value)}
                                        required>
                                        <option value="D">Detail</option>
                                        <option value="S">Summary</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={settlementGenerateType} onChange={e => setSettlementGenerateType(e.target.value)}
                                        required>
                                        <option value="V">View</option>
                                        <option value="D">Download</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Row>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-6 col-6'>
                        <Form.Label>Location Filter</Form.Label><br />
                        <LocationSelector onDataFromChild={handleDataFromChild} />
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {/* {scr === "V" ? <>
                    <Row>
                        <Col>
                            <Button onClick={() => setScr('')} variant="primary">Back</Button>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                    &nbsp;
                    <Table responsive striped bordered>
                        <thead>
                            <tr>
                                <th>Branch</th>
                                <th>In Type</th>
                                <th>Prefix</th>
                                <th>In Date</th>
                                <th>Out Date</th>
                                <th>Out Serial no.</th>
                                <th>Out Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                manualReportList.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.tmb_location + item.entity_name}</td>
                                        <td>{item.tmb_type}</td>
                                        <td>{item.tmb_prefix}</td>
                                        <td>{item.tmb_date}</td>
                                        <td>{item.tmbb_out_date}</td>
                                        <td>{item.tmbb_out_srno}</td>
                                        <td>{item.tmbb_out_type}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </> : null} */}

            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_vtm_profitability;